<template>
  <div class="number" style="margin-top: 0.4rem;text-align: center;">
    暂无数据~
  </div>
</template>

<script>
export default {};
</script>

<style></style>
